var _defs, _rect, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOtpVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1350,
    viewBox: "0 0 1080 1350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "otpGradient",
    x1: 0,
    y1: 0,
    x2: 1080,
    y2: 1350,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f172a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#1e3a8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d4ed8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "otpGlow",
    cx: 0.5,
    cy: 0.5,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38bdf8",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38bdf8",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1350,
    fill: "url(#otpGradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 260,
    r: 160,
    fill: "url(#otpGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 920,
    cy: 520,
    r: 200,
    fill: "url(#otpGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480,
    cy: 1040,
    r: 220,
    fill: "url(#otpGlow)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 420,
    width: 620,
    height: 420,
    rx: 36
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 500,
    width: 460,
    height: 260,
    rx: 28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 560,
    width: 340,
    height: 140,
    rx: 20
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260 290c0-22 18-40 40-40h160c22 0 40 18 40 40v40c0 22-18 40-40 40H300c-22 0-40-18-40-40v-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 290c0-22 18-40 40-40h160c22 0 40 18 40 40v40c0 22-18 40-40 40H620c-22 0-40-18-40-40v-40z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 880,
    r: 36
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 740,
    cy: 880,
    r: 36
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpVerify);
export default __webpack_public_path__ + "static/media/otp-verify.bb2977a3ace7822662dbb18c9dc5cc35.svg";
export { ForwardRef as ReactComponent };